import { render, staticRenderFns } from "./ManagementEvaluationForm.vue?vue&type=template&id=38740a6e&scoped=true&"
import script from "./ManagementEvaluationForm.vue?vue&type=script&lang=js&"
export * from "./ManagementEvaluationForm.vue?vue&type=script&lang=js&"
import style0 from "./ManagementEvaluationForm.vue?vue&type=style&index=0&id=38740a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38740a6e",
  null
  
)

export default component.exports